import React from 'react'
import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'

const StyledBox = styled(Box)`
  ${({ theme: { colors, space } }): string =>
    `
      box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16);
      border: 1px solid ${colors['gray-300']};
      border-radius: 4px;
      min-width: 320px;

      @media print {
        break-inside: avoid;
        page-break-inside: avoid;
        position: relative;
      }
    `};
`

const WidgetWrapper: React.FC = ({ children }) => {
  return <StyledBox>{children}</StyledBox>
}

export default WidgetWrapper
